
export const getChildren = (categoriesByUri, parent) => {
    return Object
        .values(categoriesByUri)
        .filter(c => !c.deleted)
        .filter(c => c.parent === parent)
        .toSorted((f, s) => f.order - s.order);
}

export const buildCategoriesByUri = categories =>
    Object.fromEntries(
        categories.map((c, i) => ([c.uri, { ...c, order: i }]))
    );

export const getTails = categories => {
    const categoryUris = new Set(categories.map(c => c.uri));
    categories.forEach(category => categoryUris.delete(category.parent));
    return [...categoryUris];
};

export const formatMoney = (amount, currency) => {
    if(!currency) {
        return "-";
    }
    return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency
    }).format(amount);
}

